import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AppState } from 'src/app/app.states';
import { Store, select } from '@ngrx/store';
import { take, map, tap, filter, first, finalize } from 'rxjs/operators';
import { BankAccountsActions } from '../state/bank-accounts.action-types';
import { bankAccountsLoaded } from '../state/bank-accounts.selectors';
import { LoadAll } from '../state/bank-accounts.actions';

@Injectable({
  providedIn: 'root'
})
export class BankAccountsResolver implements Resolve<boolean> {
    loading = false;

    constructor (private store: Store<AppState>) { }

    resolve(route: ActivatedRouteSnapshot,
            state: RouterStateSnapshot): Observable<boolean> {

              return this.store
              .pipe(
                  select(bankAccountsLoaded),
                  tap(_bankAccountsLoaded => {
                      if(!this.loading && !_bankAccountsLoaded) {
                          this.loading = true;
                          this.store.dispatch(LoadAll());
                      }
                  }),
                  filter(_bankAccountsLoaded => _bankAccountsLoaded),
                  first(),
                  finalize(() => this.loading = false)
              );
              /*
      return this.store.select(bankAccountsLoaded)
      .pipe(
          tap(loaded => {
              if(!loaded) {
                  this.store.dispatch(LoadAll());
              }   
          }),
          filter(loaded => !!loaded),
          first()
      );*/



    }
}
